import React, { useCallback } from 'react'
import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Unstable_Grid2'
import { useTrackHomeEnterpriseEvent } from '../../hooks/useTrackHomeEnterpriseEvent'
import { HOME_SECTION_TYPE } from './home-sections'

const multiNoWrap = lines => {
  return {
    lineClamp: lines,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical'
  }
}

export const BrowseByCategoriesRails = ({
  browseByCategoriesSection
}) => {
  const { items } = browseByCategoriesSection
  const { trackClickEvent } = useTrackHomeEnterpriseEvent()

  const navigate = useNavigate()
  const handleClick = useCallback((item) => {
    console.log('Navigating to category:', item.id)
    if (!item?.id) {
      console.error('Invalid item:', item)
      return
    }
    const path = `/${item.id}/${item.staticUrl}`

    trackClickEvent(HOME_SECTION_TYPE.BROWSE_BY_CATEGORIES, {
      categoryId: item.id,
      categoryTitle: item.title
    })

    navigate(path, { replace: true })
  }, [navigate, trackClickEvent])

  return (
    <Card data-test='home-browse-by-categories-rails' sx={{ backgroundColor: (theme) => theme.palette.grey.shade[3] }}>
      <CardContent sx={{ m: 0, p: 0, '&:last-child': { pb: 0 } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, backgroundColor: (theme) => theme.palette.grey.shade[7], borderBottom: '1px solid #E0E0E0' }}>
          <Typography sx={{ fontWeight: 700 }}>Browse By Category</Typography>
        </Box>
        <Grid container spacing={2} sx={{ p: 2 }}>
          {items.map((item, index) => (
            <Grid
              key={item.id}
              xs={12}
              sm={6}
              md={4}
              lg={2}
              sx={{ display: 'flex' }}
            >
              <Button
                data-test={`home-browse-by-category-item-${index}`}
                key={item.id}
                onClick={() => handleClick(item)}
                sx={{
                  borderColor: '#BFBFBF',
                  minHeight: 60,
                  maxHeight: 60,
                  height: '100%'
                }}
                fullWidth
                variant='outlined'
              >
                <Typography
                  sx={({ typography }) => ({ ...typography.body.s, ...multiNoWrap(2) })}
                >
                  {item.title}
                </Typography>
              </Button>
            </Grid>
          ))}
        </Grid>

      </CardContent>
    </Card>
  )
}
